import { render, staticRenderFns } from "./PopUpGreeting.vue?vue&type=template&id=e87f3c2a&scoped=true&"
import script from "./PopUpGreeting.vue?vue&type=script&lang=ts&"
export * from "./PopUpGreeting.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpGreeting.vue?vue&type=style&index=0&id=e87f3c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87f3c2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconEmojiGreeting: require('/usr/www/nuxt/components/Icon/IconEmojiGreeting.vue').default})
